import React from "react";
import { Button, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useThemeContext } from "../../context/ThemeContext";

const CustomButton = ({
  text,
  onClick,
  color = "primary",
  variant = "contained",
  fullWidth = false,
  size = "medium",
  startIcon,
  endIcon,
  disabled = false,
  customColor,
}) => {
  const { mode } = useThemeContext();
  const isDarkMode = mode === "dark";

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // <600px
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600–900px

  return (
    <Button
      onClick={onClick}
      color={color}
      variant={variant}
      fullWidth={fullWidth || isMobile} // mobile thì luôn full width
      size={isMobile ? "small" : size}
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={disabled}
      sx={{
        borderRadius: isMobile ? "6px" : "8px",
        textTransform: "none",
        fontWeight: "bold",
        px: isMobile ? 1.5 : isTablet ? 2 : 3,
        py: isMobile ? 0.5 : 1,
        fontSize: isMobile ? "0.75rem" : isTablet ? "0.85rem" : "0.95rem",
        backgroundColor:
          variant === "contained"
            ? customColor || (isDarkMode ? "#444" : "#4CAF50")
            : "transparent",
        color:
          variant === "contained"
            ? "#fff"
            : customColor || (isDarkMode ? "#ddd" : "#4CAF50"),
        "&:hover": {
          backgroundColor:
            variant === "contained"
              ? customColor
                ? customColor
                : isDarkMode
                ? "#555"
                : "#388E3C"
              : "rgba(0,0,0,0.04)",
        },
        "&.Mui-disabled": {
          backgroundColor: "#ddd",
          color: "#888",
        },
      }}
    >
      {text}
    </Button>
  );
};

export default CustomButton;
